import { Action } from '@ngrx/store';
import { TimeWindow, TimeWindowsReq } from '@cemex-core/cmx-api/models/time-windows';

export const RESET = '[Time windows bulk cem ul] Reset';

export const BULK_CEM_UL_LOAD_TIME_WINDOWS = '[Time windows bulk cem ul] Load Time Windows request';
export const BULK_CEM_UL_LOAD_TIME_WINDOWS_FROM_PLANT =
  '[Time windows bulk cem ul] Load Time Windows request from plant';
export const BULK_CEM_UL_LOAD_TIME_WINDOWS_COMPLETE = '[Time windows bulk cem ul] Load Time Windows request Complete';

export class LoadTimeWindowsAction implements Action {
  readonly type = BULK_CEM_UL_LOAD_TIME_WINDOWS;

  constructor(public payload: TimeWindowsReq) {}
}

export class LoadTimeWindowsFromPlantAction implements Action {
  readonly type = BULK_CEM_UL_LOAD_TIME_WINDOWS_FROM_PLANT;

  constructor(public payload: TimeWindowsReq) {}
}

/**
 * Fired on receipt of the time-window data
 */
export class LoadTimeWindowsCompleteAction implements Action {
  readonly type = BULK_CEM_UL_LOAD_TIME_WINDOWS_COMPLETE;

  constructor(public payload: TimeWindow[]) {}
}

export class TimeWindowsResetAction implements Action {
  readonly type = RESET;

  constructor() {}
}

export type TimeWindowsActions = LoadTimeWindowsAction | LoadTimeWindowsCompleteAction | TimeWindowsResetAction;
